//RecordDetailHeaderActions.tsx
import React from "react";
import { Box, Button, useMediaQuery } from "@mui/material";

type ApplicationHeaderProps = {
  status: String;
  onClickUseThisFormat: () => void;
};

/**
 * 申請詳細画面のヘッダーアクションコンポーネント
 * - 「この申請内容をコピーして申請」ボタンを表示する
 * - props: status (申請ステータス), onClickUseThisFormat (コピー申請ボタンクリック時の処理)
 */
export const RecordDetailHeaderActions: React.FC<ApplicationHeaderProps> = ({
  status,
  onClickUseThisFormat,
}) => {
  const isMobile = useMediaQuery("(max-width:600px)"); // 600px以下の場合はスマートフォンデバイス

  return (
    <Box>
      {/* 申請記録・承認管理一覧の参照画面における右上のボタン
      スマートフォンデバイスの場合はテーブルコンテナの下部に表示 */}
      <Box
        position="relative"
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mx: isMobile ? 1 : 0,
          my: 1.5,
          gap: 1,
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {/* <Button
          key="download"
          variant="contained"
          color="primary"
          sx={{ width: isMobile ? "100%" : "auto" }}
        >
          ダウンロード (PDF)
        </Button>*/}
        {/* {status !== "Canceled" && ( */}
        <Button
          key="copy"
          variant="outlined"
          color="primary"
          sx={{ width: isMobile ? "100%" : "auto" }}
          onClick={onClickUseThisFormat}
        >
          この申請内容をコピーして申請
        </Button>

        {/* )}  */}
      </Box>
    </Box>
  );
};
